import { render } from "./Boton.vue?vue&type=template&id=3b882fda&scoped=true"
import script from "./Boton.vue?vue&type=script&lang=js"
export * from "./Boton.vue?vue&type=script&lang=js"

import "./Boton.vue?vue&type=style&index=0&id=3b882fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b882fda"]])

export default __exports__